export const UPDATE_DRAFT_POST_REPLY_VARIABLES = {
  id: '',
  username: '',
  userId: '',
  textBlocks: [],
  categories: [],
  status: '',
  article: false,
  parentPostId: '',
  postReplyDraftId: '',
};
